module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7787/images/default-avatar.png"